export type VerificationStatus = "draft" | "on_moderation" | "verified" | "rejected"

export interface IOrganization {
    inn: string | null
    kpp: string | null
    name: string
    legal_full_name: string | null
    registration_address: string | null
    verification_status: VerificationStatus
    verification_comment: string | null
    verification_submitted_at: string | null
    verification_resolved_at: string | null
}

export interface IContactPerson {
    full_name: string | null
    position: string | null
    phone: string
    email: string
    submitted_at: string | null
}

export enum PhoneConfirmationStatus {
  PHONE_CONFIRMATION_STATUS_NEW = 0,
  PHONE_CONFIRMATION_STATUS_CODE_SENT = 1,
  PHONE_CONFIRMATION_STATUS_ERROR_ON_SENDING = 2,
  PHONE_CONFIRMATION_STATUS_CONFIRMED = 3,
  PHONE_CONFIRMATION_STATUS_EXPIRED = 4,
  PHONE_CONFIRMATION_STATUS_ERROR = 5,
  PHONE_CONFIRMATION_TOO_MANY_ATTEMPTS = 6,
}

export interface IPhoneConfirmation {
    id: string
    phone: string
    status: PhoneConfirmationStatus
    createdDate: Date | string | null
    invalidCodeAttempts: number
    maxInvalidCodeAttempts: number
}

export interface IRequestPhoneConfirmationCodeRequest {
    phone: string
}

export interface IPhoneConfirmationResponse {
    id: string
    phone: string
    status: PhoneConfirmationStatus
    created_date: Date | string | null
    invalid_code_attempts: number
    max_invalid_code_attempts: number
}

export interface IRequestEmailConfirmationCodeRequest {
    email: string
}

export interface IEmailConfirmationResponse {
    id: string
    email: string
    status: PhoneConfirmationStatus
    created_date: Date | string | null
    invalid_code_attempts: number
    max_invalid_code_attempts: number
}

export interface IRegisterOrganizationRequest {
    inn: string
    kpp?: string
    organization_name: string
    legal_full_name?: string
    registration_address?: string
    email: string
    phone: string
    password: string
    phone_confirmation_id: string
    phone_confirmation_code: string
    email_confirmation_id: string
    email_confirmation_code: string
}

export interface IRegisterOrganizationResponse {
    tokens: {
        access_token: string
        refresh_token: string
    }
    profile: {
        organization: IOrganization
        contact: IContactPerson | null
    }
}

export interface IProfileResponse {
    organization: IOrganization
    contact: IContactPerson | null
}

export interface IUpdateContactRequest {
    full_name: string
    position: string
    phone: string
    email: string
}

export interface IDashboardStatusResponse {
    organization: IOrganization
    contact: IContactPerson | null
}

export interface IDashboardCard {
    id?: string
    clientId: string
    bankTypeId: number
    number: string
    paymentSystemTypeId: number
    bankTypeName: string
    loaderTypeName: string
    paymentSystemTypeName: string
    alias?: string | null
    status?: "active" | "inactive"
    createdAt?: string
    updatedAt?: string
}

export type IDashboardCardsResponse = IDashboardCard[]

export interface ICreateBusinessCardRequest {
    bank_type_id: number
    payment_system_type_id: number
    number: string
    hash: string
}

export interface ICreateBusinessCardResponse extends IDashboardCard {}

export interface IDashboardTransaction {
    id: string
    isReturn: boolean
    timeStamp: string
    total: number
    discountTotal: number
    bonusTotal: number
    taxTotal: number
    oldTotal: number
    rrn: string | null
    merchantId: string | null
    terminalId: string | null
    fnSerialNumber: string | null
    documentNumber: string | null
    fiscalSign: string | null
    storeName: string | null
    cardNumber: string | null
}

export interface IDashboardTransactionsRequest {
    start_date?: string
    end_date?: string
    card_id?: string
    page?: number
    limit?: number
}

export interface IDashboardTransactionsResponse {
    items: IDashboardTransaction[]
    totalCount: number
    totalPages: number
    aggregate: {
        totalSum: number
        totalOldSum: number
        totalBonus: number
        totalDiscount: number
        totalTax: number
        transactionCount: number
    }
}